<template>
    <div v-if="!noPermission" class="form-wrapper">
        <v-tabs
            v-model="selectedTab"
            fixed-tabs
            background-color="black"
            dark
            :key="assignment.type"
        >
            <v-tabs-slider color="#FFC000"></v-tabs-slider>
            <v-tab v-for="tab in this.getAvailableTabsBasedOnType" :key="tab.name" :disabled="assignment.id  ? shouldDisableTab(tab.value) : false">
                {{ removeAccents(tab.name) }}
            </v-tab>
        </v-tabs>
        <v-divider class="mb-4"/>
        <assignment-tab v-if="selectedTabValue === 'assignment'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <autopsy-tab v-else-if="selectedTabValue === 'autopsy'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <earthwork-tab v-else-if="selectedTabValue === 'earthwork'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <blowing-tab v-else-if="selectedTabValue === 'blowing'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <construction-tab v-else-if="selectedTabValue === 'construction'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <welding-measurement-tab v-else-if="selectedTabValue === 'welding'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <oto-tab v-else-if="selectedTabValue === 'oto'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <activation-tab v-else-if="selectedTabValue === 'activation'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <back-office-tab v-else-if="selectedTabValue === 'backOffice'" :canEdit="canEditTab" :assignment="assignment" :currentUser="currentUser" @assignment-refresh="getAssignmentById"/>
        <alert :show-alert="showAlert" :message="message" :type="type" />
        <div v-if="assignment.contractorFrom" class="send-to-contractor-btn-wrapper">
            <v-btn class="mx-2 white--text send-to-contractor-btn" small color="black" @click="sendAssignmentBackToContractor">
                Update {{ assignment.contractorFrom.name }} <v-icon dark>mdi-upload</v-icon>
            </v-btn>
        </div>
    </div>
    <div v-else class="no-permission">
        Δεν έχετε τα απαραίτητα δικαιώματα για να δείτε αυτή την Ανάθεση
    </div>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'
    import AssignmentTab from '@/form-tabs/AssignmentTab'
    import AutopsyTab from '@/form-tabs/AutopsyTab'
    import EarthworkTab from '@/form-tabs/EarthworkTab'
    import BlowingTab from '@/form-tabs/BlowingTab'
    import ConstructionTab from '@/form-tabs/ConstructionTab'
    import WeldingMeasurementTab from '@/form-tabs/WeldingMeasurementTab'
    import OtoTab from '@/form-tabs/OtoTab'
    import ActivationTab from '@/form-tabs/ActivationTab'
    import BackOfficeTab from '@/form-tabs/BackOfficeTab'
    import userService from '@/services/user'

    export default {
        name: 'AssignmentTotalTab',
        components: { Alert, AssignmentTab, AutopsyTab, EarthworkTab, BlowingTab, ConstructionTab, WeldingMeasurementTab, OtoTab, ActivationTab, BackOfficeTab },
        watch: {
            selectedTab: {
                handler(newVal, oldVal) {
                    this.tabSelect(newVal)
                }
            },
            getAvailableTabsBasedOnType: {
                handler(newVal, oldVal) {
                    this.setTabToShow()
                }
            }
        },
        computed: {
            config() {
                return this.$store.getters.getConfig || {}
            },
            pilotTabs() {
                return [{ value: 'assignment', name: 'ΑΝΑΘΕΣΗ' }, ...this.config?.stagesPerAssignmentType['PILOT'] || []]
            },
            lastDropTabs() {
                return [{ value: 'assignment', name: 'ΑΝΑΘΕΣΗ' }, ...this.config?.stagesPerAssignmentType['LAST_DROP'] || []]
            },
            malfunctionTabs() {
                return [{ value: 'assignment', name: 'ΑΝΑΘΕΣΗ' }, ...this.config?.stagesPerAssignmentType['MALFUNCTION'] || []]
            },
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            is6digitAssignmentSR() {
                return this.assignment.sr?.length === 6
            },
            getAvailableTabsBasedOnType() {
                switch (this.assignment.type) {
                case 'PILOT': return this.pilotTabs.filter(tab => (this.clientTabs.includes(tab.value) || tab.value === 'assignment' || (tab.value === 'backOffice' && this.containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], this.userRoles))) && (this.is6digitAssignmentSR ? (tab.value !== 'oto' && tab.value !== 'activation') : true))
                case 'LAST_DROP': return this.lastDropTabs.filter(tab => this.clientTabs.includes(tab.value) || tab.value === 'assignment' || (tab.value === 'backOffice' && this.containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], this.userRoles)))
                case 'MALFUNCTION': return this.malfunctionTabs.filter(tab => this.clientTabs.includes(tab.value) || tab.value === 'assignment' || (tab.value === 'backOffice' && this.containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR'], this.userRoles)))
                default: return [this.pilotTabs[0]]
                }
            }
        },
        data: () => {
            return {
                clientTabs: [],
                selectedTab: 0,
                selectedTabValue: 'assignment',
                tabFromRoute: null,
                assignment: {},
                showAlert: false,
                message: null,
                type: null,
                loading: false,
                mode: null,
                editMode: false,
                canEditTab: false,
                noPermission: false,
                currentUser: {}
            }
        },
        created() {
            this.getCurrentUser()
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
            if (this.assignmentId) {
                this.getAssignmentById()
                this.checkIfTabCanBeEdited(this.assignmentId, this.selectedTabValue)
            }
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            sendAssignmentBackToContractor() {
                assignmentService.sendAssignmentBackToContractor(this.assignment.id).then(resp => {
                    this.setAlert('Η ανάθεση στάλθηκε πίσω στην ' + this.assignment.contractorFrom.name, 'success')
                }).catch(e => {
                    if (e.response?.data?.code === 'INTEGRATION_ERROR') {
                        this.setAlert('Η ανάθεση στον εργολάβο ' + e.response.data.message + ' απέτυχε να αποσταλλεί στο σύστημα του. Επικοινωνήστε με τον διαχειριστή', 'error')
                    } else if (e?.response?.data) {
                        this.setAlert(e?.response?.data.message, 'error')
                    }
                })
            },
            async getCurrentUser() {
                const resp = await userService.getCurrentUser()
                this.currentUser = resp.data
            },
            removeAccents(str) {
                return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            },
            tabSelect(tab) {
                this.selectedTabValue = this.getAvailableTabsBasedOnType[tab].value
                if (this.assignmentId) {
                    this.checkIfTabCanBeEdited(this.assignmentId, this.selectedTabValue)
                }
                if (this.$route.query.tab !== this.selectedTabValue) {
                    this.$router.push({ query: { tab: this.selectedTabValue } })
                }
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            selectEditMode() {
                this.readOnly = false
                this.clearable = true
                this.editMode = true
            },
            checkIfTabCanBeEdited(assignmentId, tab) {
                assignmentService.canEditTab(assignmentId, tab).then(resp => { this.canEditTab = resp.data.content })
            },
            getAssignmentById() {
                this.noPermission = false
                assignmentService.getAssignment(this.assignmentId)
                    .then(resp => {
                        this.assignment = { ...resp.data }
                        this.clientName = this.assignment.client.name
                        this.clientTabs = this.assignment.client?.assignmentTabs || []
                    }).catch(e => {
                        if (e?.response?.data?.code === 'ACCESS_DENIED') {
                            this.noPermission = true
                        }
                    })
            },
            setTabToShow() {
                const tabValue = this.getAvailableTabsBasedOnType.find(tab => tab.value === (this.$route.query.tab ? this.$route.query.tab : 'assignment'))?.value
                if (!tabValue || this.shouldDisableTab(tabValue)) {
                    this.selectedTab = 0
                    this.selectedTabValue = 'assignment'
                    this.$router.push({ query: {} })
                    return
                }
                const tabValueIndex = this.getAvailableTabsBasedOnType.findIndex(tab => tab.value === tabValue)
                if (tabValueIndex) {
                    this.selectedTab = tabValueIndex
                    this.selectedTabValue = tabValue
                }
                if (this.assignmentId) {
                    this.checkIfTabCanBeEdited(this.assignmentId, this.selectedTabValue)
                }
            },
            shouldDisableTab(tabValue) {
                if (this.assignment.type === 'MALFUNCTION' || this.assignment.notFromImport) {
                    return false
                }
                switch (tabValue) {
                case 'backOffice':
                    return false
                case 'assignment':
                    return false
                case 'autopsy':
                    return !(this.assignment.id && this.assignment?.client && this.assignment?.sr && this.assignment?.contractor)
                case 'earthwork':
                    return !((this.assignment?.autopsy && this.assignment?.contractor && this.assignment.autopsy?.nextStepsAt && this.assignment.autopsy.commentsForConstruction?.earthwork?.option !== 'COMPLETED'))
                case 'blowing':
                    return !((this.assignment?.autopsy && this.assignment?.contractor && this.assignment.autopsy?.nextStepsAt && this.assignment.autopsy.commentsForConstruction?.blowing?.option !== 'COMPLETED'))
                case 'construction':
                    return !((this.assignment?.autopsy && this.assignment?.contractor && this.assignment.autopsy?.nextStepsAt))
                case 'welding':
                    return !((this.assignment?.construction && this.assignment?.contractor && this.assignment?.construction?.status === 'COMPLETED'))
                case 'oto':
                    return !(this.assignment.type === 'LAST_DROP' || (this.assignment?.construction && this.assignment?.contractor && this.assignment?.construction?.status === 'COMPLETED' && !this.is6digitAssignmentSR))
                case 'activation':
                    return !(this.assignment.type === 'LAST_DROP' || ((this.assignment?.oto && this.assignment?.contractor && (this.assignment?.oto?.status === 'COMPLETED' || this.assignment?.oto?.status === 'EXTRA_CHARGE'))) || ((this.isNova || this.is6digitAssignmentSR) && this.assignment?.welding?.status === 'COMPLETED'))
                default: return true
                }
            }
        }
    }
</script>
<style scoped>
.send-to-contractor-btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}
@media only screen and (min-width: 950px) {
    .form-wrapper {
        padding-left: 2rem;
    }
}

.no-permission {
    height: 70vh !important;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
}

</style>
